import React from 'react';
import ReactDOM from 'react-dom/client';

import './assets/scss/Index.scss';
import './assets/scss/Mediaqueries.scss';
import './assets/scss/FloatingPieces.scss';
import './assets/scss/KeyFrameAnimations.scss';
import './assets/scss/ModalInstructions.scss';
import './assets/scss/ModalRobotsViewer.scss';

import Main from './routes/Main';

import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import es_language from "./translations/es.json";
import en_language from "./translations/en.json";

i18next.init({
  interpolation: 
  { 
    escapeValue: false // Allows for HTML tags in translations
  },  
  lng: "es",
  resources: {
    es: {
      global: es_language
    },
    en: {
      global: en_language
    }  
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18next}>
      <Main />
    </I18nextProvider>    
  </React.StrictMode>
);
